import { useCallback, useEffect, useState } from "react";

/**
 * Exibe um popup apenas uma vez por navegador (localStorage).
 * Incremente a versão da chave se precisar exibir novamente no futuro.
 */
export function useOncePopup(storageKey, { delayMs = 1500 } = {}) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    try {
      if (localStorage.getItem(storageKey) === "1") {
        return undefined;
      }
    } catch {
      return undefined;
    }

    const timer = window.setTimeout(() => setIsOpen(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [storageKey, delayMs]);

  const dismiss = useCallback(() => {
    try {
      localStorage.setItem(storageKey, "1");
    } catch {
      // localStorage indisponível (modo privado, quota, etc.)
    }
    setIsOpen(false);
  }, [storageKey]);

  return { isOpen, dismiss };
}
